export enum TimePart {
  hours = 'hours',
  minutes = 'minutes'
}
